import React, { useMemo } from 'react';
import { TimeUnit } from '../../../../utils/apollo/graphqlSchema';
import { SingleSelectMenu } from '../../../Dropdown';
import { getCapitalizedTimeUnitText } from '../../../../utils';

interface IProps {
  value: TimeUnit;
  timeUnits: TimeUnit[];
  onChange: (unit: TimeUnit) => void;
}

const TimeUnitMenu = ({ value, timeUnits, onChange }: IProps) => {
  const handleChange = (newTimeUnitString: string) => {
    onChange(newTimeUnitString as TimeUnit);
  };
  const options = useMemo(
    () =>
      timeUnits.map((timeUnit) => ({
        text: getCapitalizedTimeUnitText(timeUnit).adverb,
        value: timeUnit,
      })),
    [timeUnits],
  );

  return (
    <SingleSelectMenu
      options={options}
      value={value}
      onChange={handleChange}
      customWidth="90px"
      menuMaxHeight={200}
    />
  );
};

export default TimeUnitMenu;
